<template>
  <div class="logAudit">
   <div>
   <img class="ju-body" src="../../../assets/images/joinus.jpg">
 </div>

   <div class="tittle-white">
        
    </div> 
        

 
    
    
    
    
  </div>
</template>

<script>
export default {
  data() {
    return {
      
    };
  }
};
</script>
<style lang="scss" scoped>




.tittle-white{
  width: 100%;
	height: 50px;
  color:#ffffff;
}

.ju-body{
    display: block;
    // width: 100%;
    max-width: 100%;
    margin: 0 auto;
}











// 移动端css
@media screen and (max-width: 767px) {
  .the-banner{
    height: 260px;
    background-image: url("../../../assets/images/joinus.jpg");
  }
  
}
</style>